import { useState } from "react";
import "./Header.css";
import { useLocation, useNavigate } from "react-router-dom";
import CustomModal from "../CustomModel/CustomModel";
import JobForm from "../CreateJobForm/JobForm";
import CustomDrawer from "../CustomDrawer";
import { Button, Dialog } from "@mui/material";
import { Close } from "@mui/icons-material";
import TickSVG from "../../assets/redesign/tick-03.svg";
import { useCreatedJobData } from "../../context/MasterContextProvider";

interface Props {
  title: string;
}

const SecondaryHeader = ({ title }: Props) => {
  const { openCreateJob, setOpenCreateJob } = useCreatedJobData();

  const navigate = useNavigate();

  const handleOpenAddUserDrawer = () => {
    setOpenCreateJob(true);
  };

  const handleCloseDrawer = () => {
    setOpenCreateJob(false);
  };

  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const handleLogoutConfirm = () => {
    setModalOpen(false);
    localStorage.clear();
    navigate("/");
  };

  const location = useLocation();
  const path = location.pathname;

  function capitalizeFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const firstname = localStorage.getItem("firstname") || "";
  // const lastname = localStorage.getItem("lastname") || '';
  let fullName = `${firstname}`;
  let welcomeMessage = `Welcome, ${capitalizeFirstLetter(fullName)}`;

  const getPage = () => {
    if (path === "/dashboard") return welcomeMessage;
    else return title;
  };

  const [openDialog, setOpenDialog] = useState(false);

  const handleDialogOpen = () => {
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const handleGoToJobs = () => {
    navigate("/dashboard/jobsposted");
    setOpenDialog(false);
  };

  const handleDone = () => {
    handleCloseDrawer();
    handleDialogOpen();
  };

  const handleCreateNew = () => {
    setOpenDialog(false);
    handleOpenAddUserDrawer();
  };

  return (
    <div>
      <header className="main_header_container">
        <div className="userGreeting">
          <h2 className="header-title">{getPage()}</h2>
          <Button onClick={handleOpenAddUserDrawer}>Create Job</Button>
        </div>
      </header>

      <CustomModal
        body="Do you want to logout"
        message="Are you sure?"
        primaryBtnLabel="Yes"
        secondaryBtnLabel="No"
        onPrimary={handleLogoutConfirm}
        open={modalOpen}
        onSecondary={() => setModalOpen(false)}
        hideSecondaryBtn={false}
        modalStyle={{ backgroundColor: "white" }}
        modalSize="small"
        messageTypographyStyle={{
          font: "normal normal bold 20px/28px Mulish",
          display: "flex",
          justifyContent: "flex-start",
        }}
        bodyTypographyStyle={{
          font: "normal normal  18px/28px Mulish",
          display: "flex",
          justifyContent: "flex-start",
        }}
        playAnimation={false}
        buttonStyles={{ display: "flex", justifyContent: "flex-end" }}
      />
      <CustomDrawer
        open={openCreateJob}
        onClose={handleCloseDrawer}
        title="Create Job"
      >
        <JobForm
          handleDone={handleDone}
          defaultValue={{
            jobName: "",
            jobDesc: "",
            jobReq: "",
            minSalary: 0,
            maxSalary: 0,
            currencyId: 1,
            currencyName: "AED",
            countryId: "",
            countryName: "United Arab Emirates",
            workStateId: "",
            workState: "",
            minExp: 0,
            maxExp: 5,
            jobLevel: "",
            jobLevelId: 0,
            jobType: "Full Time",
            industryId: 0,
            industryName: "",
            workTypeId: 0,
            workType: "",
            vacancy: 1,
            qualTypeId: 0,
            qualTypeName: "Bachelors",
            skills: [],
          }}
        />
      </CustomDrawer>

      <Dialog onClose={handleDialogClose} open={openDialog}>
        <div className="job_done_container">
          <Close onClick={handleDialogClose} className="dialog_close_btn" />
          <img src={TickSVG} />
          <h3>Your job post has been created successfully</h3>
          <Button onClick={handleGoToJobs}>Check jobs</Button>
          <br />
          <button onClick={handleCreateNew} className="secondaryNewBtn">
            Create another job post
          </button>
        </div>
      </Dialog>
    </div>
  );
};

export default SecondaryHeader;
